module.exports = __webpack_public_path__ + "static/media/learn2.b51030e3.jpeg";